import { render, staticRenderFns } from "./DisponibilizacaoMaterial.vue?vue&type=template&id=08abfff6&"
import script from "./DisponibilizacaoMaterial.vue?vue&type=script&lang=js&"
export * from "./DisponibilizacaoMaterial.vue?vue&type=script&lang=js&"
import style0 from "./DisponibilizacaoMaterial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports